import { toast } from "react-toastify";

const MAX_IMAGE_SIZE = 4 * 1024 * 1024; // 4MB
const ALLOWED_TYPES = ["image/png", "image/jpeg"];

export const handleFiles = (files, setImages) => {
  const fileArray = Array.from(files);
  fileArray.forEach((file) => {
    if (!ALLOWED_TYPES.includes(file.type)) {
      toast.warn("Only PNG and JPG images are allowed.");
      return;
    }
    if (file.size > MAX_IMAGE_SIZE) {
      toast.warn("Image size must be 4MB or less.");
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      setImages((prev) => [...prev, reader.result]);
    };
    reader.readAsDataURL(file);
  });
};

export const handleDrag = (e, setDragActive) => {
  e.preventDefault();
  e.stopPropagation();
  if (e.type === "dragenter" || e.type === "dragover") {
    setDragActive(true);
  } else if (e.type === "dragleave") {
    setDragActive(false);
  }
};

export const handleDrop = (e, setDragActive, setImages) => {
  e.preventDefault();
  e.stopPropagation();
  setDragActive(false);

  if (e.dataTransfer.files && e.dataTransfer.files[0]) {
    handleFiles(e.dataTransfer.files, setImages);
  }
};

export const handleChange = (e, setImages) => {
  if (e.target.files && e.target.files[0]) {
    handleFiles(e.target.files, setImages);
  }
};

export const removeImage = (index, setImages) => {
  setImages((prev) => prev.filter((_, i) => i !== index));
};
